"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssigneeEditCell = void 0;
const react_1 = __importDefault(require("react"));
const table_cells_1 = require("../../../../common/table-cells");
const AssigneeEditCell = ({ id, field, value, options, isLoading, showNoOptionsText, }) => (react_1.default.createElement(table_cells_1.AutocompleteEditCell, { id: id, field: field, value: value, options: options, searchable: true, clearable: true, getOptionKey: (option) => { var _a; return (_a = option.id) !== null && _a !== void 0 ? _a : option.value; }, isLoading: isLoading, showNoOptionsText: showNoOptionsText }));
exports.AssigneeEditCell = AssigneeEditCell;
